import script from "./SupportConversation.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportConversation.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/objects/SupportConversation.css?vue&type=style&index=0&id=3aa10204&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa10204"]])

export default __exports__